<template>
  <div class="manufacturing-one" v-if="manufacturingStore.factory">
    <button class="back-button" @click="$router.push('/user/manufacturing')">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="none" viewBox="0 0 20 20">
        <path d="M11.969 3.637 6.137 9.47a.75.75 0 0 0 0 1.06l5.832 5.832a.75.75 0 0 0 1.06 0 .75.75 0 0 0 0-1.06L7.727 10l5.302-5.303a.75.75 0 0 0 0-1.06.75.75 0 0 0-1.06 0z" color="#000" style="-inkscape-stroke:none"/>
      </svg>
      <span>Back to all manufactures</span>
    </button>
    <h1 v-if="manufacturingStore.factory.brandName">{{ manufacturingStore.factory.brandName }}</h1>
    <div class="manufacturing-one__city" v-if="manufacturingStore.factory.locations">
      <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 24 24" width="24" height="24">
        <path d="M12 11.8c-1.5 0-2.8-1.2-2.8-2.8s1.2-2.8 2.8-2.8 2.8 1.2 2.8 2.8-1.3 2.8-2.8 2.8zm0-4c-.7 0-1.2.6-1.2 1.2s.6 1.2 1.2 1.2 1.2-.6 1.2-1.2-.5-1.2-1.2-1.2z"/>
        <path d="M12 21.8c-.1 0-.3 0-.4-.1-.3-.2-7.3-5.1-7.3-11.7 0-2.1.8-4 2.3-5.4C8 3 9.9 2.3 12 2.3c2.1 0 4 .8 5.5 2.2 1.5 1.4 2.3 3.4 2.3 5.4 0 6.5-7 11.5-7.3 11.7-.2.1-.4.2-.5.2zm0-18c-1.7 0-3.2.6-4.4 1.8-1.2 1.1-1.8 2.7-1.8 4.3 0 4.9 4.8 9 6.2 10.1 1.5-1.1 6.2-5.2 6.2-10.1 0-1.6-.6-3.2-1.8-4.4-1.2-1.1-2.7-1.7-4.4-1.7z"/>
      </svg>
      {{ manufacturingStore.factory.locations }}
    </div>
    <div class="manufacturing-one__tags">
      <div class="tag" v-for="item in manufacturingStore.factory.categories" :key="item">{{item}}</div>
    </div>
    <div class="manufacturing-one__text-info">
      <div>
        <template v-if="manufacturingStore.factory.description">
          <p class="manufacturing-one__text-info__title">About</p>
          <p>{{ manufacturingStore.factory.description }}</p>
        </template>
        <div class="filters">
          <div>
            <template v-if="manufacturingStore.factory.sewnGoodsServices?.length">
              <p class="manufacturing-one__text-info__title">Sewn Goods Services</p>
              <ul>
                <li v-for="item in manufacturingStore.factory.sewnGoodsServices" :key="item">{{item}}</li>
              </ul>
            </template>
            <template v-if="manufacturingStore.factory.products?.length">
              <p class="manufacturing-one__text-info__title">Products</p>
              <ul>
                <li v-for="item in manufacturingStore.factory.products" :key="item">{{item}}</li>
              </ul>
            </template>
          </div>
          <div>
            <template v-if="manufacturingStore.factory.pricePoints?.length">
              <p class="manufacturing-one__text-info__title">Price Points</p>
              <ul>
                <li v-for="item in manufacturingStore.factory.pricePoints" :key="item">{{item}}</li>
              </ul>
            </template>
            <template v-if="manufacturingStore.factory.productionMinimums?.length">
              <p class="manufacturing-one__text-info__title">Production Minimums</p>
              <ul>
                <li v-for="item in manufacturingStore.factory.productionMinimums" :key="item">{{item}}</li>
              </ul>
            </template>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="map">
          <MapWithStyle
            :center="{
              lat: Number(manufacturingStore.factory.latitude),
              lng: Number(manufacturingStore.factory.longitude)
            }"
          />
        </div>
        <div class="info">
          <div class="info__item">
            <p class="manufacturing-one__text-info__title">Company info</p>
            <div class="hr"/>
            <p v-if="manufacturingStore.factory.address">{{ manufacturingStore.factory.address }}</p>
            <p v-if="manufacturingStore.factory.companyPhone">
              Phone: <a :href="`tel:${manufacturingStore.factory.companyPhone}`">
                {{ manufacturingStore.factory.companyPhone }}
              </a>
            </p>
            <br>
            <a v-if="manufacturingStore.factory.companyEmail" :href="`mailto:${manufacturingStore.factory.companyEmail}`">
              {{manufacturingStore.factory.companyEmail}}
            </a>
          </div>
          <div class="info__item">
            <p class="manufacturing-one__text-info__title">Contact Info</p>
            <div class="hr"/>
            <p v-if="manufacturingStore.factory.contactName">{{ manufacturingStore.factory.contactName }}</p>
            <p v-if="manufacturingStore.factory.contactTitle">{{ manufacturingStore.factory.contactTitle }}</p>
            <br>
            <p v-if="manufacturingStore.factory.contactPhone">Phone: <a :href="`tel:${manufacturingStore.factory.contactPhone}`">
              {{ manufacturingStore.factory.contactPhone }}
            </a></p>
            <a v-if="manufacturingStore.factory.contactEmail" :href="`mailto:${manufacturingStore.factory.contactEmail}`">
              {{manufacturingStore.factory.contactEmail}}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MapWithStyle from '@/components/MapWithStyle.vue'
import { mapStores } from 'pinia'
import { useManufacturingStore } from '@/store/pinia/manufacturing'
export default {
  name: 'manufacturingOne',
  components: { MapWithStyle },
  computed: {
    ...mapStores(useManufacturingStore),
  },
  async beforeMount () {
    await this.manufacturingStore.getFactory(this.$route.params.id)
  },
}
</script>

<style lang="scss">
.manufacturing-one {
  padding: 0 16px 40px 40px;
  color: var(--Basic-Black);
  font-family: "DM Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  p {
    margin: 0;
  }
  .filters {
    display: flex;
    gap: 40px;
    margin-top: 24px;
    ul {
      margin-right: 14px;
      margin: 8px 0 24px 14px;
    }
  }
  &__text-info {
    display: flex;
    gap: 40px;
    &__title {
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 8px;
    }
    .right {
      min-width: 55%;
      .map {
        height: 336px;
        border-radius: 12px;
      }
      .info {
        display: flex;
        flex-wrap: wrap;
        gap: 40px;
        margin-top: 40px;
        &__item {
          border-radius: 12px;
          border: 1px solid var(--Dividers);
          background: var(--Surface);
          padding: 16px;
          width: calc(50% - 20px);
          .hr {
            background: var(--Dividers);
            height: 1px;
            width: 100%;
            margin: 16px 0;
          }
          p {
            margin: 0;
          }
        }
      }
    }
  }
  h1 {
    color: var(--text_color, #1D1F29);
    font-family: Unbounded;
    font-size: 32px;
    font-weight: 600;
    line-height: normal;
    margin: 16px 0 8px;
  }
  .back-button {
    display: flex;
    flex-direction: row;
    align-items: center;
    border: none;
    background: transparent;
    margin-bottom: 16px;
    svg {
      width: 20px;
      height: 20px;
      fill: var(--Primary-Shades-Primary);
      margin-right: 4px;
    }
    span {
      color: var(--Primary-Shades-Primary);
      font-family: "DM Sans";
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
    }
  }
  &__city {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
  }
  &__tags {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    margin: 12px 0 24px;
    flex-wrap: wrap;
    .tag {
      border-radius: 4px;
      border: 1px solid var(--Dividers);
      padding: 6px 8px;
    }
  }
}
@media (max-width: 964px) {
  .manufacturing-one__text-info {
    flex-direction: column;
  }
}
@media (max-width: 760px) {
  .manufacturing-one {
    padding: 0;
  }
}
@media (max-width: 480px) {
  .manufacturing-one {
    .back-button {
      margin-bottom: 24px;
    }
    .filters {
      gap: 16px;
    }
    h1 {
      font-size: 24px;
    }
    &__text-info .right {
      .map {
        height: 205px;
      }
      .info {
        gap: 16px;
        &__item {
          width: 100%;
          max-width: 100%;
        }
      }
    }
  }
}
</style>
